module.exports = __webpack_public_path__ + "img/中小微企.981050bf.png";